import React from 'react';
import { Navigate } from 'react-router-dom';

const OrdersPage = () => {
  // Redirect to the new comprehensive order history page
  return <Navigate to="/account/order-history" replace />;
};

export default OrdersPage;
